import React from "react";
import useResizeObserver from "@react-hook/resize-observer";

/**
 * Returns the dimensions of the given target
 *
 * @param target HTML element reference
 * @return {undefined} dimensions of the target
 */
export const useSize = (target) => {
	const [size, setSize] = React.useState();
	
	React.useLayoutEffect(() => {
		setSize(target.current.getBoundingClientRect())
	}, [target]);
	
	// Where the magic happens
	useResizeObserver(target, (entry) => setSize(entry.contentRect));
	return size;
}